PJQ.models.weather = {};
PJQ.models.weather.WeatherDay = PJQ.models.BaseModel.extend({
	idAttribute: 'weatherId',
	parse: function(model){
		model = model ? model : {};

		if(model.hours != null){
			this.hours = new PJQ.collection.weather.WeatherHours(model.hours);
		}

		return model;
	},
	conditionIconUrl: function(){
		let iconId = this.get('conditionIconId');
		if(iconId > 0){
			return '/assets/modules2/global/images/weather/' + iconId.toString() + '.png';
		}
	},
	minTempDisplay: function(){
		let minTemperature = this.get('minTemperature');
		if(minTemperature != null){
			return parseInt(minTemperature).toString() + '&#176;F';
		}
	},
	maxTempDisplay: function(){
		let maxTemperature = this.get('maxTemperature');
		if(maxTemperature != null){
			return parseInt(maxTemperature).toString() + '&#176;F';
		}
	}
});

PJQ.models.weather.WeatherHour = PJQ.models.BaseModel.extend({
	idAttribute: 'weatherHourId'
});

PJQ.collections.weather = {};
PJQ.collections.weather.WeatherHours = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.weather.WeatherHour
});

PJQ.constants.weather = {
	MAX_FORECAST_DAYS: 13
};